import { ref, reactive, watch } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-b410f3e6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "over-sea-content"
};
const _hoisted_2 = {
  class: "flex-content"
};
const __default__ = {
  name: 'Google'
};
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    rules: {},
    detailForm: {}
  },
  emits: ['submitForm', 'setVisible'],
  setup(__props, {
    expose,
    emit
  }) {
    const props = __props;
    const divideList2 = ref([]); // 分成比例
    const xiaomiRef = ref(null); // VIVOref
    const xiaomiForm = reactive({
      divide: '0.5',
      pkg: '',
      appId: '',
      appSecret: '',
      id: ''
    }); // VIVO
    const validateForm = () => {
      var _xiaomiRef$value;
      (_xiaomiRef$value = xiaomiRef.value) === null || _xiaomiRef$value === void 0 || _xiaomiRef$value.validate().then(() => {
        emit('submitForm', xiaomiForm);
      }).catch(e => void 0);
    };
    watch(() => props.detailForm, n => {
      if (n) {
        xiaomiForm.pkg = n.pkg;
        xiaomiForm.id = n.id;
        xiaomiForm.appId = n.appId;
        xiaomiForm.appSecret = n.appSecret;
        divideList2.value = n.rateList;
        xiaomiForm.divide = n.divide;
      }
    }, {
      immediate: true,
      deep: true
    });
    expose({
      validateForm
    });
    return (_ctx, _cache) => {
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_form = _resolveComponent("a-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_form, {
        model: xiaomiForm,
        ref_key: "xiaomiRef",
        ref: xiaomiRef,
        rules: __props.rules,
        name: "gp-validate"
      }, {
        default: _withCtx(() => [_createVNode(_component_a_form_item, {
          name: "pkg",
          label: "包名："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: xiaomiForm.pkg,
            "onUpdate:value": _cache[0] || (_cache[0] = $event => xiaomiForm.pkg = $event),
            valueModifiers: {
              trim: true
            },
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "appId",
          label: "APPID: "
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: xiaomiForm.appId,
            "onUpdate:value": _cache[1] || (_cache[1] = $event => xiaomiForm.appId = $event),
            valueModifiers: {
              trim: true
            },
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "appSecret",
          label: "App secret："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: xiaomiForm.appSecret,
            "onUpdate:value": _cache[2] || (_cache[2] = $event => xiaomiForm.appSecret = $event),
            valueModifiers: {
              trim: true
            },
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "divide",
          label: "分成系数："
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_a_select, {
            value: xiaomiForm.divide,
            "onUpdate:value": _cache[3] || (_cache[3] = $event => xiaomiForm.divide = $event),
            options: divideList2.value
          }, null, 8, ["value", "options"])])]),
          _: 1
        })]),
        _: 1
      }, 8, ["model", "rules"])]);
    };
  }
});